type Props = {
  content: any;
  thName: string;
  fullWidth?: boolean;
  trProps?: Record<string, any>;
  tdProps?: Record<string, any>;
};

export const CustomRow = ({ content, thName, fullWidth, tdProps }: Props) => {
  return fullWidth ? (
    <>
      <tr>
        <th scope='row'>{thName}</th>
      </tr>
      <tr>
        <td
          {...tdProps}
          style={{
            ...(tdProps?.style
              ? tdProps.style
              : {
                textAlign: 'left',
                padding: '0 20px',
                height: '100%',
                wordBreak: 'break-word',
              }),
          }}
        >
          {content}
        </td>
      </tr>
    </>
  ) : (
    <tr>
      <th scope='row'>{thName}</th>
      <td
        {...tdProps}
        style={{
          ...(tdProps?.style
            ? tdProps.style
            : {
              height: '100%',
            }),
        }}
      >
        {content}
      </td>
    </tr>
  );
};
